import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: "name",
    className: "bold",
    render: function(data, type, row, meta) {
      return row.modifiable !== 'false' 
        ? renderToString(<a href={row['url']}>{data}</a>)
        : renderToString(<span>{data}</span>)
    }
  },
  { data: "slug", render: (data) => renderToString(<span>{data}</span>) },
  { data: "kind" },
  { data: "scope" },
  { data: "category", render: (data) => renderToString(<span>{data}</span>) },
  { data: "description", render: (data) => renderToString(<span>{data}</span>) },
  { data: "default_value", render: (data) => renderToString(<span>{data}</span>) },
  {
    data: 'id',
    className: 'right',
    discarded: 'discarded',
    render: (data, type, row) => {
      if (row.modifiable === 'false') {
        return '';
      }
      return row.discarded === 'true'
        ? renderToString(
            <button 
              data-custom-field-id={data} 
              className="button small green restore-custom-field" 
              type="button"
            >
              Restore
            </button>
          )
        : renderToString(
            <button 
              data-custom-field-id={data} 
              className="button small red remove-custom-field" 
              type="button"
            >
              Archive
            </button>
          )
    }
  },
]

const headers = [
  'Name',
  'API name',
  'Kind',
  'Scope',
  'Category',
  'Description',
  'Default value',
  '',
]

const filters = [
  {
    name: 'Show archived only', 
    customParam: 'show_archived', 
    kind: 'radio', 
    options: [
      { value: 1, label: 'Yes' },
    ]
  },
]

const sorters = []

const order = [[1, "asc"]]

export { columns, headers, filters, sorters, order }
